import React, { useEffect, useState, useRef } from "react";
import "../style/home.scss";
import HeaderBar from "./common/HeaderBar";
import { getCategoryList } from "../apis/GetProduct";
import PagePath from "../util/RoutePagePath";
import { routeToPage } from "../util/RouteToPage";
import { useNavigate } from "react-router-dom";
import FooterBar from "./common/FooterBar";
import row1 from "../image/row1.webp";
import row1_1 from "../image/row1-1.webp";
import row1_2 from "../image/row1-2.webp";
import row2 from "../image/row2.avif";
import row2_1 from "../image/row2-1.avif";
import row2_2 from "../image/row2-2.avif";
import row2_3 from "../image/row2-3.avif";
import row2_4 from "../image/row2-4.webp";
import row3 from "../image/row3.webp";
import row3_1 from "../image/row3-1.webp";
import row3_2 from "../image/row3-2.jpg";
import row3_3 from "../image/row3-3.jpg";
import row4 from "../image/row4.webp";
import row4_1 from "../image/row4-1.webp";
import row4_2 from "../image/row4-2.webp";
import row4_3 from "../image/row4-3.webp";
import row5 from "../image/row5.webp";
import row6 from "../image/row6.webp";
import row7 from "../image/row7.webp";

import { currency } from "./common/Common";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { EffectFade, Autoplay, Pagination } from "swiper/modules";

const Home = () => {
  const [productList, setProductList] = useState([]);
  const navigate = useNavigate();

  const [position, setPosition] = useState(50);
  const [dragging, setDragging] = useState(false);
  const ref = useRef(null);

  const onMove = (e) => {
    if (!dragging) return;

    const rect = ref.current.getBoundingClientRect();
    let x = e.clientX - rect.left;
    let percent = (x / rect.width) * 100;

    if (percent < 0) percent = 0;
    if (percent > 100) percent = 100;

    setPosition(percent);
  };

  useEffect(() => {
    let list1 = getCategoryList("Men's Leather Belts");
    let list2 = getCategoryList("Women's Leather Belts");
    let list3 = getCategoryList("Leather Goods For The Office");
    setProductList([list1]);
  }, []);

  // 鼠标悬停切换图片
  const handleHover = (listIndex, itemIndex, ishover) => {
    setProductList((prev) =>
      prev.map((list, lIdx) =>
        lIdx === listIndex
          ? {
              ...list,
              list: list.list.map((item, iIdx) =>
                iIdx === itemIndex ? { ...item, ishover } : item,
              ),
            }
          : list,
      ),
    );
  };
  return (
    <React.Fragment>
      <HeaderBar />
      <div className="">
        <div className="relative h-[800px] overflow-hidden">
          <img src={row1} alt="" className="h-full w-full object-cover" />

          {/* overlay */}
          <div className="absolute inset-0 bg-black/10" />

          {/* text */}
          <div className="absolute left-1/2 top-1/2 z-10 w-full -translate-x-1/2 -translate-y-1/2 px-6 text-white">
            <p className="text-[48px] font-light leading-tight md:text-[64px]">
              Elvorloy Leather
            </p>

            <p className="mt-5 text-sm uppercase tracking-[4px] text-white/90 md:text-base">
              Crafted The Old Way Since 2015
            </p>
          </div>
        </div>
        {/* product */}
        <div className="mx-auto my-section">
          {productList?.map((item, listIndex) => (
            <React.Fragment>
              <div key={listIndex}>
                {/* <div className="font-500 mx-auto mb-10 max-w-container text-[20px] uppercase tracking-[5px]">
                  {item?.category}
                </div> */}
                <div className="mx-auto grid cursor-pointer grid-cols-1 gap-10 gap-y-20 p-10 text-center sm:grid-cols-2 lg:grid-cols-4">
                  {item?.list?.map((i, itemIndex) => (
                    <div
                      key={itemIndex}
                      onMouseEnter={() =>
                        handleHover(listIndex, itemIndex, true)
                      }
                      onMouseLeave={() =>
                        handleHover(listIndex, itemIndex, false)
                      }
                      onClick={() =>
                        routeToPage(
                          navigate,
                          `${PagePath.PRODUCTDETAIL_PAGE}/${i.id}`,
                        )
                      }
                    >
                      <div className="bg-grey aspect-1 mb-2 overflow-hidden">
                        <img
                          src={
                            i.ishover ? (i.image[1] ?? i.image[0]) : i.image[0]
                          }
                          alt=""
                          className="object-cover"
                        />
                      </div>
                      <div className="my-4 text-[16px] uppercase">
                        {i.title}
                      </div>
                      <div className="text-[14px] font-bold text-price">
                        {currency}
                        {i.price?.toLocaleString()}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>

        <div className="grid grid-cols-4 gap-20 bg-[#edeff0] p-10 text-center">
          <div>
            <div className="m-auto w-[44px]">
              <img src={row2} alt="" />
            </div>
            <p>HANDMADE</p>
            <p>Hand Cut, Hand Sewn</p>
            <p>& Fire Branded</p>
          </div>
          <div>
            <div className="m-auto w-[44px]">
              <img src={row2_1} alt="" />
            </div>
            <p>CUSTOM DESIGN</p>
            <p>Individually Crafted</p>
            <p>Signed by Maker</p>
          </div>
          <div>
            <div className="m-auto w-[44px]">
              <img src={row2_2} alt="" />
            </div>
            <p>SMALL BATCH</p>
            <p>Vertically Integrated</p>
            <p>Community-Driven Production</p>
          </div>
          <div>
            <div className="m-auto w-[44px]">
              <img src={row2_3} alt="" />
            </div>
            <p>FULL GRAIN LEATHER</p>
            <p>Locally Sourced</p>
            <p>Locally Produced</p>
          </div>
        </div>
      </div>
      <FooterBar />
    </React.Fragment>
  );
};

export default Home;
